import React from "react";
import {
  Alert,
  Heading,
} from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";
import AccessApprovalItem from "./AccessApprovalItem";
import { isLanguageEnglish } from "../Common/utils";
import "./AccessApprovalStyle.css";

const AccessApprovalSection = (props) => {
  const { t } = useTranslation("common");
  const {
    i18n,
    usersmain,
    disabled,
    locationState,
  } = props;

  return (
    <section id="access-approval-page" className="mainBody">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <Heading level={1} headingStyle={"heading5"} className="margin-1-b">
              {!locationState[4] ? t("newuser.newUserHeading") : t("newuser.modifyheading")}
            </Heading>

            {usersmain.length > 0 && (
              <div id="accordionBox">
                {disabled &&
                  (isLanguageEnglish(i18n.language) ? (
                    <Alert>{t("access.fillauthoriserdetails")}</Alert>
                  ) : (
                    <Alert>{t("newuser.authoriserDetailsRequired")}</Alert>
                  ))}

                {usersmain.map((user, index) => (
                  <AccessApprovalItem {...props} key={index} index={index} user={user} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AccessApprovalSection;
